import axios from "axios";
import { createTransactionID } from "../util";

const win: any = window;

let config = {
    api: {
        baseURL: win["apigee_bm_base_url"],
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Correlation-Id": createTransactionID(true)
        },
    },
};

export const api = axios.create({ ...config.api });

api.defaults.validateStatus = function () {
    return true;
};

api.interceptors.request.use(
    async (conf: any) => {
        conf.headers['cem-key'] = win["CEM_KEY"];
        conf.headers["X-Source-Channel"] = "PORTAL";
        conf.headers["X-Transaction-Id"] = createTransactionID();
        conf.headers["Authorization"] = `Bearer ${win['bmToken']}`;

        return conf;
    }, (err) => {
        console.log("error in getting ", err);
    }
);

api.interceptors.response.use(
    async (response: any) => {
        return response;
    }, async (error: any) => {
        if (error.response) {
            return error.response;
        }
        return Promise.reject(error);
    }
);

const initiateLogin = (data: any) => {
    return api.post('/cem/bff/login/v1/initiate', data);
};

const resendOtp = (data: any) => {
    return api.put('/cem/bff/otp/v1/resend', data);
};

const validateAuth = (data: any) => {
    return api.post('/cem/bff/login/v1/validate', data);
};

export { initiateLogin, validateAuth, resendOtp };